<script lang="ts">
    import { goto } from "$app/navigation";
    import Time from "svelte-time/src/Time.svelte";
    export let post: any = {};
    export let handleFromShareSocialMedia: any;
    export let durationTimeCopyToClipboard: any = "";
    export let isCopyToClipboard: boolean = false;
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<article
    class="h-[27rem] rounded-2xl group cursor-pointer flex flex-col hover:scale-[102%] hover:transition-all"
>
    <div class="rounded-t-2xl relative overflow-hidden max-h-[18rem]">
        <img
            loading="lazy"
            src={`${
                post?.featured_images?.data?.[0]?.original ||
                post?.featured_images?.data?.[0]?.large ||
                post?.featured_images?.data?.[0]?.medium ||
                post?.featured_images?.data?.[0]?.thumb ||
                post?.featured_images?.data?.[0]?.small
            }`}
            alt={post?.title}
            class="rounded-t-2xl max-h-[18rem] w-full object-cover object-center-top"
        />
    </div>
    <div
        class="p-3 -mt-3 border-1 rounded-b-2xl flex flex-col justify-between flex-grow"
    >
        <div class="flex flex-col gap-2">
            <div class="mt-1">
                {#if post?.categories?.data?.length > 0}
                    <swiper-container
                        space-between={1}
                        slides-per-view={1}
                        centered-slides={false}
                        pagination={{
                            hideOnClick: true,
                        }}
                    >
                        <div class="flex flex-wrap xs:gap-1 md:gap-1 mb-1">
                            {#each post?.categories?.data?.slice(0, 2) as category, index}
                                <a
                                    href={`news/categories/${category?.slug}`}
                                    class="no-underline items-end hover:no-underline transition-colors duration-200 flex"
                                >
                                    <!-- <svg xmlns="http://www.w3.org/2000/svg" class="mt-[2px] text-red-500" width="18" height="18" aria-label="Tag Category" ><g><path d="M5.653 14.48a1.386 1.386 0 0 0 .985-.408l7.161-7.161a2.309 2.309 0 0 0 .68-1.642V1.391A1.4 1.4 0 0 0 13.085 0H9.21a2.307 2.307 0 0 0-1.642.68L.407 7.841a1.4 1.4 0 0 0 0 1.971l4.261 4.261a1.383 1.383 0 0 0 .985.407ZM13.085.929a.465.465 0 0 1 .465.465v3.875a1.384 1.384 0 0 1-.408.985l-7.161 7.162a.465.465 0 0 1-.657 0l-4.26-4.262a.466.466 0 0 1 0-.657l7.161-7.16A1.386 1.386 0 0 1 9.21.929Z"></path><path d="M10.763 5.11a1.394 1.394 0 1 0-1.394-1.393 1.395 1.395 0 0 0 1.394 1.393Zm0-1.858a.465.465 0 1 1-.465.465.465.465 0 0 1 .465-.465Z"></path></g></svg> -->
                                    <span
                                        class="text-base font-medium text-[#5C3561] text-opacity-70 mt-1 bg-slate-100/50 rounded-md hover:bg-slate-200/50 px-2"
                                        >{category?.name}</span
                                    >
                                    {#if index === 0 && post?.categories?.data?.slice(0, 2)?.length === 2}
                                        <span>{" "}, {" "}</span>
                                    {/if}
                                </a>
                            {/each}
                        </div>
                    </swiper-container>
                {:else}
                    <span
                        class="text-base font-medium text-[#5C3561] text-opacity-70 xs:gap-1 md:gap-1 mb-1 mt-1 bg-slate-100/50 rounded-md px-2 py-1 w-auto"
                        >Uncategorized</span
                    >
                {/if}
            </div>
            <div class="news__content-title pt-[1px]">
                <span
                    class="text-slate-800 capitalize font-medium line-clamp-3 text-[20px] group-hover:text-opacity-80"
                    >{post?.title}</span
                >
            </div>
            <div class="news__content-subtitle pb-[10px] h-[3rem]">
                <span
                    class="text-slate-600 line-clamp-2 text-base group-hover:text-opacity-80"
                    >{post?.excerpt}</span
                >
            </div>
        </div>
        <span
            class="text-base font-normal text-[#3E3232BF] mt-2 flex flex-row justify-between content-center"
        >
            <Time timestamp={post?.published_at} format="D MMMM YYYY" />
            <button
                class="share-button-desktop flex gap-x-2 rounded-[8px] transition-colors duration-200 cursor-pointer"
                on:click={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    // idContent = post?.id
                    handleFromShareSocialMedia(post);
                    clearTimeout(durationTimeCopyToClipboard);
                    isCopyToClipboard = false;
                }}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="text-gray-500"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    ><path
                        fill="currentColor"
                        d="m13.12 17.023l-4.199-2.29a4 4 0 1 1 0-5.465l4.2-2.29a4 4 0 1 1 .958 1.755l-4.2 2.29a4.008 4.008 0 0 1 0 1.954l4.2 2.29a4 4 0 1 1-.959 1.755M6 14a2 2 0 1 0 0-4a2 2 0 0 0 0 4m11-6a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4"
                    /></svg
                >
            </button>
        </span>
    </div>
</article>
